import { useEffect, useState, useRef } from "react";
import { ArrowRight } from "lucide-react";

// Logos reales subidos por el cliente (archivos en /app/frontend/public/images/clientes/)
// Deduplicado: Liverpool aparecía 2x (2-1 + 2-1-2) → se usa solo una vez.
const CLIENT_LOGOS = [
  { src: "/images/clientes/cliente_2-1.png", alt: "Liverpool" },
  { src: "/images/clientes/cliente_3-1.png", alt: "Mary Kay" },
  { src: "/images/clientes/cliente_4-1.png", alt: "Arena Monterrey" },
  { src: "/images/clientes/cliente_5-2.png", alt: "Axtel" },
  { src: "/images/clientes/cliente_6-2.png", alt: "Telmex" },
  { src: "/images/clientes/cliente_7-2.png", alt: "Aceromex" },
  { src: "/images/clientes/cliente_8-2.png", alt: "Daimler" },
  { src: "/images/clientes/cliente_9-2.png", alt: "ACSA" },
  { src: "/images/clientes/cliente_10-2.png", alt: "FEMSA" },
  { src: "/images/clientes/cliente_11-2.png", alt: "Walmart" },
  { src: "/images/clientes/cliente_12-2.png", alt: "Soriana" },
  { src: "/images/clientes/cliente_13-2.png", alt: "Universidad Autónoma de Nuevo León" },
  { src: "/images/clientes/cliente_14-2.png", alt: "NGK" },
  { src: "/images/clientes/cliente_16-2.png", alt: "ALEN (Cloralex)" },
  { src: "/images/clientes/cliente_17-2.png", alt: "OXXO" },
];

export default function ClientLogos() {
  const scrollToGallery = (e) => {
    e.preventDefault();
    const el = document.getElementById("proyectos");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  // Grid 5/3/2 cols
  const logos = CLIENT_LOGOS;

  return (
    <section
      data-testid="client-logos-section"
      className="relative bg-white text-[#1F2937] section-pad border-t-2 border-accent"
    >
      <div className="container-tight">
        <div className="flex items-center gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker">Clientes &amp; Proyectos</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl max-w-3xl leading-[0.95]">
          Ellos confían en <span className="text-accent">Velarias Tens</span>.
        </h2>
        <p className="mt-6 max-w-2xl text-[#1F2937]/70 text-base md:text-lg">
          Más de 100 proyectos entregados para marcas líderes en México y Latinoamérica.
        </p>

        {/* Grid 5 / 3 / 2 — logos estáticos */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-testid="client-logos-grid">
          {logos.map((logo, i) => (
            <LogoCard key={i} logo={logo} index={i} />
          ))}
        </div>

        <div className="mt-12 flex justify-center md:justify-start">
          <a
            href="#proyectos"
            onClick={scrollToGallery}
            className="inline-flex items-center gap-3 font-display font-bold text-[#1F2937] hover:text-accent transition-colors group"
            data-testid="client-logos-cta-gallery"
          >
            <span className="border-b border-[#DDE2D5] group-hover:border-accent pb-1 text-sm uppercase tracking-widest">
              Ver proyectos entregados
            </span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
}

function LogoCard({ logo, index }) {
  return (
    <div
      className="client-logo-card group relative bg-[#111] border border-white/[0.06] hover:border-[#DDE2D5] transition-colors duration-300"
      style={{ animationDelay: `${index * 40}ms` }}
      data-testid={`client-logo-${index}`}
    >
      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      <div className="relative aspect-[16/9] flex items-center justify-center p-6 md:p-8">
        <img
          src={logo.src}
          alt={logo.alt}
          loading="lazy"
          className="relative z-10 w-full h-full object-contain client-logo-img transition-all duration-300"
        />
      </div>

      <style>{`
        .client-logo-card .client-logo-img {
          filter: grayscale(1) brightness(1.6) contrast(0.9);
          opacity: 0.6;
          mix-blend-mode: luminosity;
        }
        .client-logo-card:hover .client-logo-img {
          filter: none;
          opacity: 1;
          mix-blend-mode: normal;
        }
      `}</style>
    </div>
  );
}
